import { Grid } from "@mui/material";
import { KeyDriveSecondaryButton } from "../../../../components/KeydriveComponents/Buttons/KeyDriveSecondaryButton";
import { KeyDrivePrimaryButton } from "../../../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { KeyDriveBodyMax } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

export interface IForwardBackButton {
    backStep: () => void;
    forwardStep: () => void;
}

export default function ForwardBackButton({
    backStep,
    forwardStep
}: IForwardBackButton): JSX.Element {
    return (
        <Grid item xs={12} display="flex" justifyContent="space-between" marginTop="20px" spacing={2}>
            <Grid item xs={5} marginBottom="40px">
                <KeyDriveSecondaryButton 
                    TextComponent={KeyDriveBodyMax}
                    TextComponentProps={{
                        color: "#22638D",
                        needBold: true,
                        needEllipses: false,
                        text: "Voltar"
                    }}
                    startIcon={<ArrowBackIos />}
                    needFullWidth
                    onClick={backStep}
                />
            </Grid>
            <Grid item xs={5}>
                <KeyDrivePrimaryButton 
                    TextComponent={KeyDriveBodyMax}
                    TextComponentProps={{
                        color: "white",
                        needBold: true,
                        needEllipses: false,
                        text: "Avançar"
                    }}
                    endIcon={<ArrowForwardIos />}
                    needFullWidth
                    onClick={forwardStep}
                />
            </Grid>
        </Grid>
    )
}